export default __webpack_public_path__ + "static/media/empty-folder-contacts.5ad69530.svg";